import { createSelector } from 'reselect';
import { initialState } from './reducer';

const prescoringSelector = state =>
  state.get('prescoring', initialState);

const makeSelectIsLoading = () =>
  createSelector(prescoringSelector, prescoringSelectorState =>
    prescoringSelectorState.get('loading')
  );

const makeSelectWidgetIsOpen = () =>
  createSelector(prescoringSelector, prescoringSelectorState =>
    prescoringSelectorState.get('widgetIsOpen')
  );

const makeSelectModalIsOpen = () =>
  createSelector(prescoringSelector, prescoringSelectorState =>
    prescoringSelectorState.get('modalIsOpen')
  );

const makeSelectLogic = () =>
  createSelector(prescoringSelector, prescoringSelectorState =>
    prescoringSelectorState.get('logic'),
  );

const makeSelectCheckResponse = () =>
  createSelector(prescoringSelector, prescoringSelectorState =>
    prescoringSelectorState.get('checkResponse')
  );

const makeSelectChance = () =>
createSelector(prescoringSelector, prescoringSelectorState => {
  const chance = prescoringSelectorState.get('checkResponse').chance;

  return typeof chance === 'undefined' ? null : chance
});

const makeSelectCheckInputData = () =>
  createSelector(prescoringSelector, prescoringSelectorState =>
    prescoringSelectorState.get('checkInput')
  );

const makeSelectOfferLogic = () =>
  createSelector(prescoringSelector, prescoringSelectorState =>
    prescoringSelectorState.get('offerSustainability').toJS().logic
  );

const makeSelectOfferCheckResponse = () =>
  createSelector(prescoringSelector, prescoringSelectorState =>
    prescoringSelectorState.get('offerSustainability').toJS().checkResponse
  );

const makeSelectOfferChance = () =>
createSelector(prescoringSelector, prescoringSelectorState => {
  const chance = prescoringSelectorState.get('offerSustainability').toJS().checkResponse.chance;

  return typeof chance === 'undefined' ? null : chance
});

const makeSelectOfferCheckInputData = () =>
  createSelector(prescoringSelector, prescoringSelectorState =>
    prescoringSelectorState.get('offerSustainability').toJS().checkInput
  );

const makeSelectSustainabilitySelected = () =>
  createSelector(prescoringSelector, prescoringSelectorState =>
    prescoringSelectorState.get('sustainabilitySelected').toJS()
  );

export {
  prescoringSelector,
  makeSelectWidgetIsOpen,
  makeSelectIsLoading,
  makeSelectModalIsOpen,
  makeSelectLogic,
  makeSelectCheckResponse,
  makeSelectChance,
  makeSelectCheckInputData,
  makeSelectSustainabilitySelected,
  makeSelectOfferLogic,
  makeSelectOfferCheckResponse,
  makeSelectOfferChance,
  makeSelectOfferCheckInputData,
};
